import FilterDialog from './Dialog'
import { useSelector } from 'react-redux'
import FilterButton from '../../../../filter/FilterButton'

const FilterButtonSubjects = () => {
  const open = useSelector(state => state?.filter?.subject?.open || false)

  return (
    <>
      <FilterButton 
        module='subject'
        keysFilter={[ 'curriculumId']}
      />
      { open &&
        <FilterDialog />
      }
    </>
  )
}
export default FilterButtonSubjects